import { RevealDealerEnquiryModal } from 'components/PageWrappers/SharedComponents/RevealDealerEnquiryModal/RevealDealerEnquiryModal';
import { RevealSendMessage } from 'components/PageWrappers/SharedComponents/RevealSendMessage/RevealSendMessage';
import type { EmailDealerOrSellerProps } from 'components/PageWrappers/AdDetails/components/EmailDealerOrSeller/EmailDealerOrSeller.typed';

const EmailDealerOrSeller = (props: EmailDealerOrSellerProps) => {
  const { adId, dealer, handleReveal, clickSource, dealerID } = props;

  return (
    <>
      {dealer ? (
        <RevealDealerEnquiryModal
          adId={adId}
          id={dealerID}
          handleReveal={handleReveal}
        />
      ) : (
        <RevealSendMessage adId={adId} clickSource={clickSource} />
      )}
    </>
  );
};

export { EmailDealerOrSeller };
